// extracted by mini-css-extract-plugin
export default {"carouselBtnContainer":"carousel_carouselBtnContainer__D4XR4","arrow":"carousel_arrow__6xEOp","rightArrow":"carousel_rightArrow__nAFcq"};